import { PriceBreakdownType, FilteredPriceBreakdownConfig } from '../redux/priceBreakdownReducer';

export const parseConfigs = (priceBreakdownState: PriceBreakdownType, isNewVehicle: boolean) => {
  const filteredConfig: FilteredPriceBreakdownConfig = {
    regular: isNewVehicle ? priceBreakdownState?.regular : priceBreakdownState?.usedRegular,
    dealerDiscount: isNewVehicle
      ? priceBreakdownState?.dealerDiscount
      : priceBreakdownState?.usedDealerDiscount,
    OEMDiscount: isNewVehicle
      ? priceBreakdownState?.OEMDiscount
      : priceBreakdownState?.usedOEMDiscount,
    dealerMarkup: isNewVehicle
      ? priceBreakdownState?.dealerMarkup
      : priceBreakdownState?.usedDealerMarkup,
    nonConditionalBonus: isNewVehicle
      ? priceBreakdownState?.nonConditionalBonus
      : priceBreakdownState?.usedNonConditionalBonus,
    dealerPrice: isNewVehicle
      ? priceBreakdownState?.dealerPrice
      : priceBreakdownState?.usedDealerPrice,
    dealerDocFees: isNewVehicle
      ? priceBreakdownState?.dealerDocFees
      : priceBreakdownState?.usedDealerDocFees,
    destinationAndHandlingFees: isNewVehicle
      ? priceBreakdownState?.destinationAndHandlingFees
      : priceBreakdownState?.usedDestinationAndHandlingFees,
    retail: isNewVehicle ? priceBreakdownState?.retail : priceBreakdownState?.usedRetail,
    final: isNewVehicle ? priceBreakdownState?.final : priceBreakdownState?.usedFinal,
  };
  return filteredConfig;
};
